<template>
  <div>
    <div v-if="loading" class="ui active dimmer">
      <div class="ui text loader">{{$t('Loading')}}</div>
    </div>
    <div v-else class="ui raised segment">
      <div class="ui toggle checkbox">
        <input type="checkbox" ref="cloud-splash-enabled" v-model.lazy="settings.disableCloudSplash" @change="onSwitchCloudSplash">
        <label>{{$t('Disable Cloud Splash')}}</label>
      </div>
    </div>
    <LoginGuide ref="loginGuide" action="disable" :message="$t('In order to alter the settings of this device, you need to sing in to EZCast and register this device.', {keySeparator:'#'})"/>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import LoginGuide from './LoginGuide';

export default {
  mounted() {
    if (this.isLoggedInUser) {
      this.fetchSettings(this.did);
    } else {
      this.updateSettings({
        disableCloudSplash: false,
      });
    }
  },
  updated() {
    window.$('.ui.checkbox', this.$el).checkbox();
  },
  computed: {
    loading () {
      return this.exception == undefined && this.settings == undefined;
    },
    did () {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('did');
    },
    ...mapState([
      'settings',
      'exception',
      'isLoggedInUser',
    ]),
  },
  methods: {
    onSwitchCloudSplash () {
      // eslint-disable-next-line no-console
      console.log(`onSwitchCloudSplash`, this.$refs['cloud-splash-enabled'].checked);
      const urlParams = new URLSearchParams(window.location.search);
      if (!this.isLoggedInUser && urlParams.get('redirect_url')) {        
        this.$refs.loginGuide.show();
        return;
      } else {
        this.changeSettings({
          settings: {
          disableCloudSplash: this.$refs['cloud-splash-enabled'].checked,
          },
          did: this.did,
        });
      }
    },
    ...mapActions([
      'changeSettings',
      'fetchSettings',
    ]),
    ...mapMutations([
      'updateSettings',
    ]),
  },
  components: {
    LoginGuide,
  },
}
</script>

<style scoped>
.ui.toggle.checkbox {
  width: 100%;
}

.ui.toggle.checkbox label {
    padding-left:0;
    padding-right:4em;
}

.ui.checkbox input,
.ui.toggle.checkbox label:before {
    left:auto;
    right:0;
}

.ui.toggle.checkbox label:after {
    left:auto;
    right:1.75em;
    transition:background 0.3s ease 0s, right 0.3s ease 0s;
}

.ui.toggle.checkbox input:checked + label:after {
    left:auto;
    right:0.5em;
    transition:background 0.3s ease 0s, right 0.3s ease 0s;
}
</style>
